// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles_nav__ll5RB","menu":"styles_menu__Hm8IV"};